module.exports = __webpack_public_path__ + "static/media/bw_square.8c090cbd.png";